<template>
  <div>
    <form-field-currency
      label="Retail Value"
      v-model="form.retail_value"
      :validation-errors="validationErrors.retail_value"
    />

    <form-field-input
      label="Agent Commission"
      v-model="form.agent_commission"
      type="number"
      :validation-errors="validationErrors.agent_commission"
    >
      <template v-slot:after>
        <p class="control">
          <span class="button is-small field-button">%</span>
        </p>
      </template>
    </form-field-input>

    <form-field-currency
      label="Mortgage Payoff"
      v-model="form.mortgage_payoff"
      :validation-errors="validationErrors.mortgage_payoff"
    />

    <form-field-currency
      label="Holding Costs"
      v-model="form.holding_costs"
      :validation-errors="validationErrors.holding_costs"
    />

    <form-field-currency
      label="Other Selling Costs"
      v-model="form.other_costs"
      :validation-errors="validationErrors.other_costs"
    />

    <form-field-currency
      label="Desired Profit"
      v-model="form.desired_profit"
      :validation-errors="validationErrors.desired_profit"
    />

    <hr />

    <p class="mao_value">
      Max Allowable Offer
      <span>{{ utils.formatCurrency(maxAllowableOffer, 0) }}</span>
    </p>
  </div>
</template>

<script>
import { FormMixin } from "./forms.mixin";
import utils from "../services/utils";
import api from "../api";

export default {
  name: "RetailListingAnalysisForm",
  props: ["formData"],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        record_id: this.$store.state.activeRecord.record.id,
        retail_value: "",
        agent_commission: "",
        mortgage_payoff: "",
        holding_costs: "",
        other_costs: "",
        desired_profit: "",
      },
    };
  },
  created() {
    // This allows you to pass in formData without an id to add data to the defaultForm for the creation
    this.form =
      this.formData && this.formData.id
        ? utils.clone(this.formData)
        : utils.clone({ ...this.defaultForm, ...this.formData });
  },
  computed: {
    utils() {
      return utils;
    },
    worth() {
      const retailValue = this.form.retail_value ?? 0;
      const mortgagePayoff = this.form.mortgage_payoff ?? 0;
      const holdingCosts = this.form.holding_costs ?? 0;
      const otherCosts = this.form.other_costs ?? 0;

      const totalCosts = parseFloat(holdingCosts) + parseFloat(mortgagePayoff) + parseFloat(otherCosts);

      return parseFloat(retailValue) - totalCosts;
    },
    maxAllowableOffer() {
      const desiredProfit = this.form.desired_profit ?? 0;
      return this.worth - parseFloat(desiredProfit);
    },
  },
  methods: {
    create() {
      this.form.maximum_allowable_offer = this.maxAllowableOffer;
      return api.analysis.retailListingAnalysis
        .create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Analysis was created",
            type: "is-success",
          });
          return res;
        });
    },
    update() {
      this.form.maximum_allowable_offer = this.maxAllowableOffer;
      return api.analysis.retailListingAnalysis
        .update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Analysis was updated",
            type: "is-success",
          });
          return res;
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/variables/variables";

.mao_value {
  span {
    float: right;
  }
}
</style>
